module.exports = __webpack_public_path__ + "static/media/menlopark6.eac9ffa8.jpg";